import ClientDetails from './ClientDetails'
import Mastitis from './Mastitis'
import ReviewCalving from './ReviewCalving'
import ReviewSickCows from './ReviewSickCows'
import CalfHealth from './CalfHealth'
import DownCowMeta from './DownCowMeta'
import TraceElements from './TraceElements'
import ReviewReproduction from './ReviewReproduction'
import ReviewAmu from './ReviewAmu'
import ReviewNsaids from './ReviewNsaids'
import ForecastLepto from './ForecastLepto'
import ForecastScanning from './ForecastScanning'


export const SpringSummaryComponents = {
  ClientDetails,
  Mastitis,
  ReviewCalving,
  ReviewSickCows,
  CalfHealth,
  DownCowMeta,
  TraceElements,
  ReviewReproduction,
  ReviewAmu,
  ReviewNsaids,
  ForecastLepto,
  ForecastScanning,
}
